export default __webpack_public_path__ + "static/critical-thinking-4a79941628dffe51330f5ba280ffccfd.png";